import paramsReducer from './reducers/params.js';
import nasnReducer from './reducers/nasn.js';

export default {
    nasn: { reducer: nasnReducer },
    params: {
        reducer: paramsReducer,
    },
};
